import { textMuted } from '@/theme/colors'
import styled from 'styled-components'

/** Row 1: Users + Trips (two wide cards). */
export const TopGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1.25rem;
	margin-bottom: 1.25rem;

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`

/** Row 2: Events + Ideas + Expenses (three cards). */
export const BottomGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1.25rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr 1fr;
	}
	@media (max-width: 700px) {
		grid-template-columns: 1fr;
	}
`

export const ErrorState = styled.div`
	color: ${textMuted};
	font-size: 1rem;
`
